
<template>
  <div>
    <div class="card-container">
      <common-top-form
        :model="formModel"
        @openAddDialog="changeInfo(false)"
        @success="onSuccess"
        :submitService="submitService"
        :submitData="submitData"
        addShowPower="/operationvideo/add"
        selectShowPower="/operationvideo/select"
      >
        <!-- <el-form-item label="类别" prop="type">
          <el-select v-model="formModel.type">
            <el-option
              v-for="item in typesAll"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="名称" prop="name">
          <el-input
            type="text"
            show-word-limit
            placeholder="请输入名称"
            v-model="formModel.name"
          ></el-input>
        </el-form-item>
      </common-top-form>
      <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
        <el-table-column
          prop="name"
          label="名称"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          min-width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <p>{{ scope.row.status == 1 ? "启用" : "禁用" }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="url"
          label="地址"
          min-width="360"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column
          prop="type"
          label="类别"
          min-width="160"
          :formatter="formatTranTypee"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column
          prop="serialNumber"
          label="排序"
          min-width="160"
          :formatter="formatterTableData"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="160"
          :formatter="formatterTableData"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="操作时间"
          min-width="160"
          :formatter="formatterTableData"
        ></el-table-column>
        <el-table-column label="操作" min-width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="changeInfo(true, scope.row)"
              >修改</el-button
            >
            <el-button
              type="text"
              @click="Disabled(scope.row.id, scope.row.status)"
              class="button-color"
              >{{ scope.row.status == 1 ? "禁用" : "启用" }}</el-button
            >
            <el-button
              type="text"
              @click="Delete(scope.row.id)"
              class="button-color"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </common-table>
    </div>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import APPService from "service/APPService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "operationvideo",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  mixins: [loadMixin, dialogMixin],
  data() {
    return {
      formModel: {
        // type: "",
        name: "",
      },
      tableData: [],
      formDialogTitle: "",
      // types: [
      //   {
      //     dictKey: "",
      //     dictValue: "全部",
      //   },
      // ],
      // typesAll: [],
      submitService: APPService.operationvideoList,
      page: {},
      valueId: "",
      isPage: false,
      getTatSimpleId: "",
    };
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    // this.getTypeNames("素材类型", (res) => {
    //   this.typesAll = [...this.types, ...res];
    // });
    this.getList();
  },
  activated() {
    this.getList();
  },
  computed: {
    submitData() {
      const params = {
        // type: this.formModel.type,
        name: this.formModel.name,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getDetail() {
      const params = {
        userId: this.userId,
        id: this.valueId,
      };
      this.doLoad(
        APPService.operationvideoDetail,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogModel = result;
            this.dialogModel.type = Number(this.dialogModel.type);
          });
        },
        "信息获取失败"
      );
    },
    changeInfo(isHaved, item) {
      this.$router.push({
        name: "operationvideoupdate",
        params: {
          isHaved: isHaved,
          item: JSON.stringify(item),
        },
      });
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    doDisabled(id) {
      const disabledParams = {
        userId: this.userId,
        id: id,
        status: this.status,
      };
      this.doLoad(
        APPService.operationvideoUdp,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    Disabled(id, type) {
      if (type == 0) {
        this.status = 1;
        this.showMsg = "确定启用该数据？";
      } else if (type == 1) {
        this.status = 0;
        this.showMsg = "确定禁用该数据？";
      }
      this.showConfirm(this.showMsg)
        .then(() => {
          this.doDisabled(id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      const disabledParams = {
        userId: this.userId,
        id: id,
      };
      this.doLoad(
        APPService.operationvideoDel,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    Delete(id) {
      this.showMsg = "确定删除？";
      this.showConfirm(this.showMsg)
        .then(() => {
          this.doDelete(id);
        })
        .catch(() => {});
    },
    // formatTranTypee(row, column, cellValue) {
    //   let value = "";
    //   this.typesAll.forEach((item) => {
    //     if (item.dictKey == cellValue) {
    //       value = item.dictValue;
    //     }
    //   });
    //   return value ? value : "--";
    // },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/OperationVideo.vue